var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-steps',{attrs:{"active":_vm.active}},[_c('van-step',[_vm._v("基本注册")]),_c('van-step',[_vm._v("实名认证")]),_c('van-step',[_vm._v(_vm._s(_vm.authTitle))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }